export type SideHeaderProps = {
    mobileOnly: boolean,
    name: string
}

export function SideHeader(props: React.PropsWithChildren<SideHeaderProps>) {
    return (
        <div className={"w-100 bg-secondary sideheader p-2 " + (props.mobileOnly ? " d-lg-none" : "")}>{props.name}</div>
    );
}